import RegistrationSurveyUserThird from "./RegistrationSurveyUserThird";
export default RegistrationSurveyUserThird